module.exports = __webpack_public_path__ + "img/il.66d49a1a.svg";